<template>
  <div class="filterbar">
    <div class="logo-print" />
    <PostFilters v-if="activeRoute.name === 'homePage'" />
    <CommunityPostFilters v-if="activeRoute.name === 'communityPage'" />
    <CommunityFilters v-if="activeRoute.name === 'communitiesPage'" />
    <AdministratorFilters v-if="isAdminRoute" />
  </div>
</template>
<script>
import PostFilters from './PostFilters'
import CommunityFilters from './CommunityFilters'
import AdministratorFilters from './AdministratorFilters'
import CommunityPostFilters from './CommunityPostFilters'

export default {
  name: 'FilterBar',
  components: { PostFilters, CommunityPostFilters, CommunityFilters, AdministratorFilters },
  computed: {
    activeRoute() {
      return this.$store.getters.activeRoute
    },
    isAdminRoute() {
      return this.$store.getters.isAdminRoute
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.filterbar {
  //font-family: 'Barlow', Arial, 'Open Sans', normal, sans-serif;
  width: 100%;
  max-height: 60px;
  top: 83px;
  position: initial;
  bottom: 0;

  ::-webkit-scrollbar {
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background:   #e0e0e0;
    border-radius: 50px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $secondary-color;
    border-radius: 100px;
    border: 1px solid $secondary-color;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    //background: $secondary-color;
  }

}

</style>
